<template>
  <div>
    <div>
      <slot name="default"/>
    </div>
    <div>
      <slot name="error" v-bind:validationError="validationErrorMessage" v-bind:failedRules="failedRules">
        <div class="text-riseup-danger-red">
          {{ validationErrorMessage }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import WithValidation from '@/mixins/WithValidation';

export default {
  name: 'Validate',
  mixins: [WithValidation],
  watch: {
    async validatedValue(oldValue, newValue) {
      if (oldValue !== newValue) {
        await this.validate();
      }
    },
  },
};
</script>
